const Sidebar = ({ isOpen, setIsOpen }) => {
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative">
      <div
        className={`fixed inset-0 z-40 transition-opacity ${
          isOpen ? "opacity-50" : "opacity-0 pointer-events-none"
        } bg-black`}
        onClick={toggleSidebar}
      ></div>
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 transition duration-300 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } bg-white shadow-lg`}
      >
        <div className="flex items-center justify-between h-16 px-4 bg-gray-800">
          <h1 className="text-white">Sidebar Title</h1>
          <button
            className="text-gray-500 focus:outline-none"
            onClick={toggleSidebar}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6L6 18"></path>
              <path d="M6 6L18 18"></path>
            </svg>
          </button>
        </div>
        <div className="p-4">
          <p className="text-gray-800">Sidebar content goes here.</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
